// extracted by mini-css-extract-plugin
module.exports = {"table":"EventsTable_table__3OYoZ","head":"EventsTable_head___q9bJ","title":"EventsTable_title__3H5DR","register":"EventsTable_register__dMsSe"};